import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import NewUserDashboardMobile from "./NewUserDashboardMobile";
import NewUserDashboardWeb from "./NewUserDashboardWeb";

export default function NewUserDashboard() {
  const location = useLocation(); // Catch the state from FilterLeads
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");
    const handler = () => setIsMobile(media.matches);
    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, []);

  // PASS PROPS: Pass the location object to children
  return isMobile ? (
    <NewUserDashboardMobile location={location} />
  ) : (
    <NewUserDashboardWeb location={location} />
  );
}